import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { CostReviewLineItemPurchase } from '../../components/cost-review-line-item/cost-review-line-item-purchase';
import { PhoneVerificationContextProvider } from '../../components/phone-verification/context';

export const CostReviewLineItemPurchaseContainer = (props) => {
  const userHasPurchasingRole = useSelector(Global.selectUserhasPurchasingRole);
  const hasPersonalShipsurance = useSelector(Global.selectSellerPersonalShipsuranceAccount);
  const insuranceOrPostagePurchaseError = useSelector(Global.selectBulkInsurancePurchaseErrorMessage);

  return (
    <PhoneVerificationContextProvider>
      <CostReviewLineItemPurchase
        {...props}
        hasPersonalShipsurance={hasPersonalShipsurance}
        insuranceOrPostagePurchaseError={insuranceOrPostagePurchaseError}
        userHasPurchasingRole={userHasPurchasingRole}
      />
    </PhoneVerificationContextProvider>
  );
};
